export const ProblemTypes = {
  Emergency: "Emergency",
  FollowUp: "FollowUp",
  Ears: "Ear",
  Eyes: "Eye",
  Gastrointestinal: "Gastrointestinal",
  General: "General",
  Mobility: "Mobility",
  Mouth: "Mouth",
  Respiratory: "Respiratory",
  renalUrinary: "Urinary",
  Skin: "Skin & Coat",
  Others: "Others",
};

export const symptomsTypes = {
  notEating: "Not eating",
  vomitting: "Vomiting",
  looseStools: "Loose stools",
  constipation: "Constipation",
  worms: "Worms",
  indiscriminateEating: "Indiscriminate eating",
  draggingBottom: "Dragging bottom",

  frequentUrination: "Frequent urination",
  incontinence: "Incontinence",
  painful: "Painful",
  straining: "Straining",
  dribbling: "Dribbling",
  kidneyFailure: "Kidney Failure",
  others: "Other",
  dischargePenis: "Discharge - Penis",
  bleedingPenis: "Bleeding - Penis",
  swellingPenis: "Swelling/growth - Penis",
  dischargeVulva: "Discharge - Vulva",
  bleedingVulva: "Bleeding - Vulva",
  swellingVulva: "Swelling/growth - Vulva",

  weightLoss: "Weight loss",
  weightGain: "Weight gain",
  lethargy: "Lethargy",
  motionSickness: "Motion sickness/Travel",
  excessThirst: "Excess Thirst",
  shivering: "Shivering",
  pregnancy: "Pregenancy",
  other: "Other",
};

export const paymentStatusEnum = {
  paid: "Paid",
  partiallypaid: "Partially Paid",
  unpaid: "Unpaid",
};

export const paymentKeyword = {
  partiallypaid: "partiallypaid",
  paid: "paid",
  unpaid: "unpaid",
  cancelled: "cancelled",
};

export const mealTypesEnum = {
  afterMeal: "After Meal",
  beforeMeal: "Before Meal",
  afterFood: "After Food",
  beforeFood: "Before Food",
  withFood: "With Food",
  onEmptyStomach: "On Empty Stomach",
};

export const billingTabEnum = {
  Treatment: "treatment",
  Pharmacy: "pharmacy",
  "Pet Shop": "petShop",
  Clinic: "treatment", // handled from procedure
  treatment: "TREATMENT",
  pharmacy: "PHARMACY",
  petShop: "PETSHOP",
};

export const payTabEnum = {
  Treatment: "TREATMENT",
  Pharmacy: "PHARMACY",
  "Pet Shop": "PETSHOP",
  Clinic: "TREATMENT",
};

export const tabEnum = {
  Clinic: "Clinic",
  PHARMACY: "Pharmacy",
  PETSHOP: "Pet Shop",
  TREATMENT: "Clinic",
  petShop: "Pet Shop",
  pharmacy: "Pharmacy",
  treatment: "Clinic",
  "Pet Shop": "Pet Shop",
  Pharmacy: "Pharmacy",
  CLINIC: "Clinic",
  Petshop: "Pet Shop",
};

export const genderEnum = {
  male: "Male",
  female: "Female",
  Unknown: "Unknown",
};

export const diagStatusEnum = {
  "Pending Review": "Clinician Review",
  "Patient Review": "Patient Review",
  "In Progress": "In Progress",
  "Pending Approval": "Pending Approval",
  Completed: "Completed",
  Cancelled: "Cancelled",
  Scheduled: "Scheduled",
  "In progress": "In progress",
};

export const inputTypeEnum = {
  Numeric: "Numeric",
  TextBox: "Text Box",
  DropDown: "Drop Down",
  "Text Box": "Text Box",
  "Drop Down": "Drop Down",
};

export const frequencyEnum = {
  morning: "Morning",
  afternoon: "Afternoon",
  night: "Night",
  onceDaily: "Once daily",
  twiceDaily: "Twice daily",
  threeTimesDaily: "Three times daily",
  fourTimesDaily: "Four times daily",
  every12Hours: "Every 12 hours",
  every8Hours: "Every 8 hours",
  every4Hours: "Every 4 hours",
};

export const frequencyConEnum = {
  Morning: "morning",
  Afternoon: "afternoon",
  Night: "night",
  "Once daily": "onceDaily",
  "Twice daily": "twiceDaily",
  "Three times daily": "threeTimesDaily",
  "Four times daily": "fourTimesDaily",
  "Every 12 hours": "every12Hours",
  "Every 8 hours": "every8Hours",
  "Every 4 hours": "every4Hours",
};

export const checkoutEnum = {
  Clinic: "Clinic",
  Pharmacy: "Pharmacy",
  "Pet Shop": "Petshop",
};

export const appointmentTypeEnum = {
  Physical: "Physical",
  Virtual: "Virtual",
  Home: "Home Visit",
};

export const statusMap = {
  Upcoming: "scheduled",
  "Checked-in": "inprogress",
  "In Transit": "intransit",
  Consultation: "consultation",
  Billing: "finalize",
  Completed: "completed",
  Cancelled: "cancelled",
};
